
    import React from 'react';
    import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
    import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
    import SpriteSymbolComponent from "../../../../../../tools/webpack/svgSpriteLoader/icon.tsx";

    const symbol = new SpriteSymbol({
  "id": "icon-check-outline-24_TZZ6b",
  "use": "icon-check-outline-24_TZZ6b-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"currentColor\" id=\"icon-check-outline-24_TZZ6b\">\n<g transform=\"translate(3 5.4)\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M17.7364 0.263603C18.0878 0.615075 18.0878 1.18492 17.7364 1.5364L6.6364 12.6364C6.46761 12.8052 6.2387 12.9 6 12.9C5.76131 12.9 5.53239 12.8052 5.3636 12.6364L0.263604 7.5364C-0.0878682 7.18492 -0.0878678 6.61508 0.263604 6.2636C0.615076 5.91213 1.18492 5.91213 1.5364 6.2636L6 10.7272L16.4636 0.263604C16.8151 -0.0878679 17.3849 -0.0878681 17.7364 0.263603Z\" />\n</g>\n</symbol>"
});
    sprite.add(symbol);

    const IconCheckOutline_24Tzz6bSpriteSymbolComponent = props => {
      return React.createElement(SpriteSymbolComponent, {glyph: "icon-check-outline-24_TZZ6b", width: 24, height: 24, ...props })
    }

    export { IconCheckOutline_24Tzz6bSpriteSymbolComponent as ReactComponent };
  